import { Box } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../UserContext";
import { Banner } from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";





const Home = () => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user) {
        window.location.href="/login";
      }
    }, [user]);
    
    useEffect(() => {
        document.body.classList.add("homepage");
        return () => {
          document.body.classList.remove("homepage");
        };
      }, []);

    return(
    <Box className="flex">
        <Box className="sidebar_"><Sidebar /></Box>
        <Banner />
    </Box>
    )
}

export default Home;